import "./JVPartnership.module.css";
import VaultHeader from "@/reusable_sections/Header";
import JointVenture from "./sections/JointVenture";
import Qualifications from "./sections/Qualifications";
import PartnerInquiry from "./sections/PartnerInquiry";
import VaultFooter from "@/reusable_sections/Footer";
export default function JVPartnershipPage() {
  return <div>
      <VaultHeader />
      <JointVenture />
      <Qualifications />
      <PartnerInquiry />
      <VaultFooter />
    </div>;
}